export default "__VITE_ASSET__CLL0i6FO__"